import type { MuiTheme as Theme } from '@paintscout/ui'
import { makeStyles } from '@paintscout/ui'
import { useTrialDashboardDesktopTypographyStyles } from '../../shared/useTrialDashboardDesktopTypographyStyles'

const responsiveSpacing = 'clamp(40px, 5vw, 150px)'
const MIN_HEIGHT_VIEWPORT = 'calc(100vh - 200px)'
const FULL_WIDTH_OFFSET = 'calc(100% + 64px)'
const CENTER_OFFSET = 'calc(50% - 32px)'
const CENTER_TRANSFORM = 'translate(-50%, -50%)'
const BORDER_BOX = 'border-box'
const TRANSLATE_Y_CENTER = 'translateY(-50%)'

const useLayoutStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(6),
    minHeight: MIN_HEIGHT_VIEWPORT,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'visible',
    width: '100%',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3),
      gap: theme.spacing(4),
      minHeight: MIN_HEIGHT_VIEWPORT
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: MIN_HEIGHT_VIEWPORT,
      gap: theme.spacing(6)
    }
  },
  whiteBackground: {
    position: 'absolute',
    width: FULL_WIDTH_OFFSET,
    maxWidth: 'none',
    height: 'auto',
    minHeight: '347.452px',
    flexShrink: 0,
    border: '1.19px solid #D9DEE8',
    backgroundColor: '#FFFFFF',
    zIndex: 0,
    top: '40%',
    left: CENTER_OFFSET,
    transform: CENTER_TRANSFORM,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    borderRadius: theme.shape.borderRadius,
    display: 'block',
    visibility: 'visible',
    opacity: 1,
    pointerEvents: 'none',
    paddingTop: 0,
    paddingRight: '50px',
    paddingBottom: 0,
    paddingLeft: '50px',
    boxSizing: BORDER_BOX,
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 64px)',
      maxWidth: '832.074px',
      minHeight: '303.083px',
      padding: theme.spacing(3)
    },
    [theme.breakpoints.up('lg')]: {
      width: FULL_WIDTH_OFFSET,
      maxWidth: 'none',
      left: CENTER_OFFSET,
      transform: CENTER_TRANSFORM,
      paddingTop: 0,
      paddingRight: '50px',
      paddingBottom: 0,
      paddingLeft: '50px',
      overflow: 'hidden'
    },
    '@media (min-width: 1214px)': {
      paddingRight: '50px',
      paddingLeft: '50px'
    },
    [theme.breakpoints.up('xl')]: {
      width: FULL_WIDTH_OFFSET,
      maxWidth: 'none',
      left: CENTER_OFFSET,
      transform: CENTER_TRANSFORM,
      borderRadius: theme.shape.borderRadius,
      paddingTop: 0,
      paddingRight: '50px',
      paddingBottom: 0,
      paddingLeft: '50px',
      overflow: 'hidden'
    }
  },
  leftSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    position: 'absolute',
    top: '40%',
    left: 0,
    transform: TRANSLATE_Y_CENTER,
    zIndex: 2,
    maxWidth: '690.926px',
    padding: 0,
    marginLeft: 0,
    flexShrink: 1,
    minWidth: 0,
    width: '50%',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      padding: theme.spacing(2),
      position: 'relative',
      top: 'auto',
      transform: 'none',
      width: '100%'
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '600px',
      flexShrink: 1
    },
    [theme.breakpoints.up('xl')]: {
      position: 'absolute',
      top: '40%',
      left: 0,
      transform: TRANSLATE_Y_CENTER,
      maxWidth: '600px',
      flexShrink: 1
    },
    '@media (min-width: 1850px)': {
      maxWidth: '690.926px'
    }
  },
  leftSectionContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: '50px',
    boxSizing: BORDER_BOX,
    [theme.breakpoints.up('lg')]: {
      paddingTop: '50px',
      paddingLeft: '50px',
      paddingRight: 0
    },
    '@media (min-width: 1214px)': {
      paddingLeft: responsiveSpacing,
      paddingRight: 0
    }
  },
  rightSection: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '40%',
    right: 0,
    transform: TRANSLATE_Y_CENTER,
    zIndex: 2,
    paddingRight: '50px',
    flexShrink: 1,
    minWidth: 0,
    width: '50%',
    [theme.breakpoints.up('lg')]: {
      paddingRight: '50px',
      boxSizing: BORDER_BOX
    },
    '@media (min-width: 1214px)': {
      paddingRight: '50px'
    },
    [theme.breakpoints.up('xl')]: {
      position: 'absolute',
      top: '40%',
      right: 0,
      transform: TRANSLATE_Y_CENTER,
      paddingRight: '50px',
      boxSizing: BORDER_BOX,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }
}))

export const useSherwinTrialOverDashboardDesktopLayoutStyles = () => {
  const layoutStyles = useLayoutStyles()
  const typographyStyles = useTrialDashboardDesktopTypographyStyles()
  return { ...layoutStyles, ...typographyStyles }
}
